import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Box,
  Button,
  Collapse,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import { awsIntegratedKeys } from "../../../../api/queryKeys";
import TextWithExternalLink from "../../../../components/ExternalLink";

const PermissionsSummary = () => {
  const [isVisible, setIsVisible] = useState(false);
  const colors = useColors();
  const { getCloudFormationURL } = useAPI();

  const { data: CloudFormationPublicURL } = useQuery({
    queryKey: awsIntegratedKeys.cloudFormation(),
    queryFn: getCloudFormationURL,
    select: (res) => res.data,
  });

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const getListItem = (name, description) => {
    return (
      <ListItem sx={{ padding: "0px" }}>
        <ListItemText
          primary={
            <Typography variant="body2" sx={{ fontWeight: "bold" }}>
              • {name}
            </Typography>
          }
          secondary={<Typography variant="body2">{description}</Typography>}
        />
      </ListItem>
    );
  };

  return (
    <Box
      sx={{
        margin: "20px 0",
        borderRadius: "8px",
        padding: "16px",
        width: "100%",
      }}
    >
      <Button
        onClick={toggleVisibility}
        endIcon={isVisible ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        sx={{
          textTransform: "none",
          color: colors.primary_main,
        }}
      >
        What will be created?
      </Button>

      <Collapse in={isVisible} timeout="auto" unmountOnExit>
        <Box sx={{ marginTop: "16px" }}>
          <Typography
            variant="subtitle1"
            sx={{
              marginBottom: "16px",
            }}
          >
            The CloudFormation stack will create an IAM role with the following
            permissions:
          </Typography>
          <Typography variant="subtitle2">AWS Managed Policies</Typography>
          <List sx={{ marginLeft: "20px", padding: 0 }}>
            {getListItem(
              "ViewOnlyAccess",
              "Provides read-only access to all AWS services."
            )}
            {getListItem(
              "SecurityAudit",
              "Grants audit-level access to review security configurations and logs."
            )}
          </List>

          <Typography variant="subtitle2">Inline Policies</Typography>
          <List sx={{ marginLeft: "20px", padding: 0 }}>
            {getListItem(
              "SSMGetServiceSetting",
              "Allows access to retrieve System Manager service settings."
            )}
            {getListItem(
              "BackupPolicy",
              "Enables access to backup vaults and metadata for recovery planning."
            )}
            {getListItem(
              "SSO",
              "Provides permissions to view AWS Single Sign-On (SSO) users, groups, and instances."
            )}
            {getListItem(
              "FullAnalysis",
              "Grants read permissions for in-depth analysis across AWS services."
            )}
          </List>
          <TextWithExternalLink
            text="* To see the full CloudFormation template, click "
            linkText="here"
            href={CloudFormationPublicURL}
          />
        </Box>
      </Collapse>
    </Box>
  );
};

export default PermissionsSummary;
